import { useEffect, useState } from 'react';
import api from '../api';

/* Llamadas manuales desde InnovaChat: genera la llave que vincula este cliente con una cuenta
   de InnovaChat (se muestra UNA vez; aqui solo se guarda su huella) y fija la tarifa por minuto
   de esas llamadas cuando salen por la troncal Innovabot. */
export default function LlamadasInnovaChat({ clienteId }) {
  const [info, setInfo] = useState(null);
  const [llave, setLlave] = useState('');
  const [tarifa, setTarifa] = useState('');
  const [ocupado, setOcupado] = useState(false);
  const [msg, setMsg] = useState('');

  const cargar = async () => {
    try {
      const r = await api.get(`/manual/admin/clientes/${clienteId}`);
      setInfo(r.data);
      setTarifa(r.data.tarifa_manual_minuto ?? '');
    } catch { setInfo(null); }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { cargar(); }, [clienteId]);

  const generar = async () => {
    if (info?.vinculada && !window.confirm('Ya hay una llave. Si generas otra, la cuenta de InnovaChat dejará de llamar hasta que pegues la nueva. ¿Continuar?')) return;
    setOcupado(true); setMsg('');
    try {
      const r = await api.post(`/manual/admin/clientes/${clienteId}/llave`);
      setLlave(r.data.llave);
      cargar();
    } catch { setMsg('No se pudo generar la llave'); }
    setOcupado(false);
  };

  const revocar = async () => {
    if (!window.confirm('La cuenta de InnovaChat vinculada dejará de poder llamar. ¿Revocar la llave?')) return;
    await api.delete(`/manual/admin/clientes/${clienteId}/llave`).catch(() => {});
    setLlave(''); cargar();
  };

  const guardarTarifa = async () => {
    setOcupado(true); setMsg('');
    try {
      await api.put(`/manual/admin/clientes/${clienteId}/tarifa`, { tarifa_manual_minuto: tarifa === '' ? null : Number(tarifa) });
      setMsg('Tarifa guardada');
    } catch (e) { setMsg(e?.response?.data?.detail || 'No se pudo guardar la tarifa'); }
    setOcupado(false);
  };

  if (!info) return null;
  const inp = { background: 'var(--bg)', border: '1px solid var(--surface-2)', borderRadius: 8, color: 'var(--text)', padding: '8px 12px', fontSize: 13, boxSizing: 'border-box' };
  const btn = (bg) => ({ background: bg, color: '#fff', border: 'none', borderRadius: 8, padding: '8px 14px', cursor: 'pointer', fontWeight: 600, fontSize: 12.5 });

  return (
    <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, padding: 20, marginBottom: 16 }}>
      <h3 style={{ color: 'var(--text)', fontSize: 14, fontWeight: 700, margin: '0 0 4px' }}>Llamadas manuales desde InnovaChat</h3>
      <p style={{ color: 'var(--text-3)', fontSize: 12, margin: '0 0 14px' }}>
        Asesores humanos llamando desde el CRM, sin IA. Usan el saldo de este cliente y, si tiene troncal propia, salen por ella sin costo por minuto.
      </p>

      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 14 }}>
        <span style={{ fontSize: 12, color: info.vinculada ? 'var(--success)' : 'var(--text-3)' }}>
          {info.vinculada ? '● Vinculado con InnovaChat' : '○ Sin vincular'}
        </span>
        <button disabled={ocupado} onClick={generar} style={btn('var(--accent-solid)')}>{info.vinculada ? 'Generar llave nueva' : 'Generar llave'}</button>
        {info.vinculada && <button onClick={revocar} style={btn('var(--danger)')}>Revocar</button>}
      </div>

      {llave && (
        <div style={{ background: 'var(--surface)', borderRadius: 8, padding: 12, marginBottom: 14 }}>
          <div style={{ fontSize: 11, color: 'var(--warning)', marginBottom: 6 }}>Cópiala ahora: no se vuelve a mostrar. Pégala en InnovaChat → Superadmin → la cuenta → Plan y permisos.</div>
          <div style={{ display: 'flex', gap: 8 }}>
            <input readOnly value={llave} onFocus={e => e.target.select()} style={{ ...inp, flex: 1, fontFamily: 'monospace' }} />
            <button onClick={() => navigator.clipboard?.writeText(llave)} style={btn('var(--surface-2)')}>Copiar</button>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, flexWrap: 'wrap' }}>
        <div>
          <label style={{ fontSize: 11, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Tarifa por minuto (troncal Innovabot)</label>
          <input type="number" min={10} max={2000} placeholder={`${info.tarifa_defecto} (por defecto)`} value={tarifa}
            onChange={e => setTarifa(e.target.value)} style={{ ...inp, width: 200 }} />
        </div>
        <button disabled={ocupado} onClick={guardarTarifa} style={btn('var(--surface-2)')}>Guardar tarifa</button>
        {msg && <span style={{ fontSize: 12, color: 'var(--text-3)' }}>{msg}</span>}
      </div>
    </div>
  );
}
